import React from 'react';
import pt from 'prop-types';

import { Stack, TextField, Typography } from '@metarouter-private/mr-mui';

const INPUT_PROPS = { 'data-test-id': 'commitMessageInput' };

export default function CommitMessageModalContent({ commitMessage, onChange }) {
  const handleChange = event => onChange(event.target.value);

  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        Share some information about the changes made in this revision. Details are saved in the Revision History tab.
      </Typography>
      <TextField
        label="Revision Details"
        value={commitMessage}
        onChange={handleChange}
        placeholder="e.g. Added custom event mapping for checkout flow"
        fullWidth
        autoFocus
        multiline
        rows={3}
        inputProps={INPUT_PROPS}
      />
    </Stack>
  );
}

CommitMessageModalContent.propTypes = {
  commitMessage: pt.string.isRequired,
  onChange: pt.func.isRequired,
};
